module.exports = __webpack_public_path__ + "img/7_130.08c15572.png";